require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-did-the-world-bank-incorporate-child-protection.json") })
        }
      }, "path---en-us-update-how-did-the-world-bank-incorporate-child-protection");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-did-the-world-bank-incorporate-child-protection!./.cache/json/en-us-update-how-did-the-world-bank-incorporate-child-protection.json
// module id = 731
// module chunks = 231608221292675